import { Action } from "redux";

export type AuthRenewSession = "AUTH_RENEW_SESSION";
export const AUTH_RENEW_SESSION: AuthRenewSession = "AUTH_RENEW_SESSION";

export interface AuthRenewSessionAction extends Action {
    type: AuthRenewSession;
}

export function renewSession(timeout: number): AuthRenewSessionAction {
    return {
        type: AUTH_RENEW_SESSION
    };
}
